// extracted by mini-css-extract-plugin
export default {"center":"Otp-center-d1d4","inputStyle":"Otp-inputStyle-dd65","row":"Otp-row-fa4d","right":"Otp-right-fb3e","barcode":"Otp-barcode-a117"};